document.addEventListener("DOMContentLoaded", async () => {
	const { initTabs } = await import("@utils/tabs");
	initTabs();
});
